export default "__VITE_ASSET__Ci8sQy7O__"